import Copy from 'copy-to-clipboard'
import event from '@/utils/event'

const copy = (value: any) => {
	Copy(value)
	event.emit('snackbar', { title: 'Copied!', variant: 'success' })
}

export default copy
